export default __webpack_public_path__ + "static/media/hvac-company.c30a6bfc.svg";